import React, {useLayoutEffect} from 'react';
import PropTypes from 'prop-types';
import { ForgeTooltip } from '@tylertech/forge-react';

const ConditionalTooltip = ({ name, targetRef }) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  useLayoutEffect(() => {
    const el = targetRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    return () => observer.disconnect();
  }, [name, targetRef]);

  if (!showTooltip) return null;

  return (
    <ForgeTooltip anchor={targetRef.current?.id}>
      {name}
    </ForgeTooltip>
  );
};

ConditionalTooltip.propTypes = {
  name: PropTypes.string.isRequired,
  targetRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};
export default ConditionalTooltip;
